class User {
  constructor(
    public readonly id: string,
    public readonly firstName: string,
    public readonly lastName: string,
    public readonly profilePhoto: string | null
  ) {}
}

export default User;
